import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { SHARED_DEFAULTS } from "@/lib/sharedSectionDefaults";

let cache = null;

const isSet = (v) => v != null && v !== "" && !(Array.isArray(v) && !v.length);
export const mergeShared = (saved) => ({
  ...SHARED_DEFAULTS,
  ...Object.fromEntries(Object.entries(saved || {}).filter(([, v]) => isSet(v))),
});
export const resetSharedCache = () => { cache = null; };

// Admin-edited shared page sections merged over the built-in defaults.
export function useSharedSections() {
  const [saved, setSaved] = useState(() => cache?.value || null);
  useEffect(() => {
    if (!cache) {
      const entry = {};
      entry.promise = api.get("/public/shared-sections")
        .then((r) => { entry.value = r.data || {}; return entry.value; })
        .catch(() => { entry.value = {}; return entry.value; });
      cache = entry;
    }
    let alive = true;
    cache.promise.then((v) => { if (alive) setSaved(v); });
    return () => { alive = false; };
  }, []);
  return useMemo(() => mergeShared(saved), [saved]);
}
